import api from './api';

const medicineService = {
  getAllMedicines: async () => {
    const response = await api.get('/api/medicines');
    return response.data;
  },

  createMedicine: async (data) => {
    const response = await api.post('/api/medicines', data);
    return response.data;
  },

  updateMedicine: async (id, data) => {
    const response = await api.put(`/api/medicines/${id}`, data);
    return response.data;
  },

  deleteMedicine: async (id) => {
    const response = await api.delete(`/api/medicines/${id}`);
    return response.data;
  },
};

export default medicineService;